import { cn } from "@/lib/utils";
import { formatFcfa } from "@/lib/format";

interface Props {
  amount: number;
  className?: string;
  compact?: boolean;
  signed?: boolean;
}

export function Money({ amount, className, compact, signed }: Props) {
  const sign = signed && amount > 0 ? "+" : "";
  return (
    <span
      className={cn(
        "tabular-nums",
        signed && amount > 0 && "text-success",
        signed && amount < 0 && "text-destructive",
        className
      )}
    >
      {sign}
      {formatFcfa(amount, { compact })}
    </span>
  );
}
